import { useEffect, useState } from "react";
import {
  getTournamentNotReservationByCafeId,
  TournamentResponse,
} from "../../../api/tournament";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import CommonTable, { TableProps } from "../../../component/CommonTable";
import styled from "styled-components";
import { formatDate } from "../../../utils/date";

export const TournamentListWrapper = styled.div`
  background-color: white;
  width: 662px;
  display: flex;
  flex-direction: column;
`;

const TournamentListContainer = styled(TournamentListWrapper)`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

const TournamentList = (props: {
  tournament: TournamentResponse | null;
  setTournament: (tournament: TournamentResponse) => void;
}) => {
  const [list, setList] = useState<TournamentResponse[]>([]);
  const pub = useRecoilValue(pubState);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { tournament, setTournament } = props;

  const itemsPerPage = 6;

  const getList = async () => {
    if (!pub) return;
    const res = await getTournamentNotReservationByCafeId(pub?.id);
    setList(res);
    setTotalPages(Math.max(1, Math.ceil(res.length / itemsPerPage)));
    setTournament(res[0]);
  };

  useEffect(() => {
    getList();
  }, []);

  const columns: TableProps<TournamentResponse>["columns"] = [
    {
      key: "createdAt",
      header: "최근 등록일자",
      render: (item) =>
        new Date(item.createdAt).toLocaleDateString("ko-KR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
      weight: 1.3,
      style: "date",
    },
    {
      key: "title",
      header: "토너먼트 이름",
      render: (item) => item.title,
      weight: 4,
      style: "name",
    },
    {
      key: "startDate",
      header: "토너먼트 시간",
      render: (item) => formatDate(item.startDate, true),
      style: "bold",
      weight: 2,
    },
  ];

  const handleRowClick = (item: TournamentResponse) => {
    setTournament(item);
  };

  const paginatedList = list.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <TournamentListContainer>
      <CommonTable<TournamentResponse>
        data={paginatedList}
        columns={columns}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        onRowClick={handleRowClick}
        selectedRow={tournament}
        emptyString="예약을 생성할 수 있는 토너먼트가 없습니다."
      />
    </TournamentListContainer>
  );
};

export default TournamentList;
